
import React from 'react';
import { useTheme } from '@/components/theme/ThemeProvider';
import { 
  Wifi, 
  Cable, 
  Satellite, 
  Radio, 
  Cloud, 
  Network
} from 'lucide-react';
import { NetworkType } from '@/components/dashboard/network/NetworkTypes';

interface NetworkTypeIconProps {
  type: NetworkType;
  size?: number;
  className?: string;
}

const NetworkTypeIcon: React.FC<NetworkTypeIconProps> = ({ 
  type, 
  size = 16, 
  className = "" 
}) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  
  // Color mapping based on network type
  const getIconColor = (type: NetworkType) => {
    switch(type) {
      case '5g':
        return isDark ? '#FF6600' : '#0078FF'; // Orange in dark, blue in light
      case 'fiber': 
        return isDark ? '#0F9DEA' : '#0EA5E9'; // Lighter blue
      case 'satcom':
        return isDark ? '#6E59A5' : '#8B5CF6'; // Purple 
      case 'radio':
        return isDark ? '#D6BCFA' : '#D946EF'; // Pink/Purple
      case 'cloud':
        return isDark ? '#00D25B' : '#10B981'; // Green
      case 'hybrid':
        return isDark ? '#F97316' : '#F97316'; // Orange
      default:
        return isDark ? '#D6BCFA' : '#8B5CF6'; // Default purple
    }
  };

  // Get Icon component based on network type
  const IconComponent = () => {
    const color = getIconColor(type);
    
    switch(type) {
      case '5g':
        return <Wifi size={size} color={color} className={className} />;
      case 'fiber':
        return <Cable size={size} color={color} className={className} />;
      case 'satcom':
        return <Satellite size={size} color={color} className={className} />;
      case 'radio':
        return <Radio size={size} color={color} className={className} />;
      case 'cloud':
        return <Cloud size={size} color={color} className={className} />;
      case 'hybrid':
        return <Network size={size} color={color} className={className} />;
      default:
        return <Wifi size={size} color={color} className={className} />;
    }
  };

  return <IconComponent />;
};

export default NetworkTypeIcon;
